import { get } from 'lodash';
import Vue from 'vue';

const Log = Vue.log({ context: { location: 'translate-filter' } });

/**
 * Fetches a translation according to a path
 * @param {string} path - The translation path, optionally deep: `category.translation_name`
 * @return {string} The translation found under the given path (if no translation was found, returns the given path)
 */
export default function translateFilter(path) {
    const translation = get(globals.config.translations, path);

    if (translation) {
        return translation;
    }

    Log.warn(`Translation path "${ path }" not found!`);
    return path;
}
